import React from 'react';
import Title from '../../../../@casino/ui/title';
import TableCasino from '../../../../@casino/ui/table';
import { useRouter } from '../../../../@casino/useRouter';
import { setGetListCodeCountry } from '../store/thunk/setGetListCodeCountry';
import { useSelector, useDispatch } from 'react-redux';
import { setPutCodeCountry } from '../store/thunk/setPutCodeCountry';

const CodeCountry = () => {
    const dispatch = useDispatch();
    const router = useRouter()

    React.useEffect(() => {
        dispatch(setGetListCodeCountry())
    }, [])

    const list = useSelector(state => state.code_country.list);
    const columns = [
        { id: 'code', label: 'Код страны'},
        { id: 'label', label: 'Пометка'},
        { id: 'length', label: 'Длина номера'},
        { id: 'country', label: 'Страна (ISO)'},
        { id: 'is_active', label: 'Активность'},
    ];

    const rows = list.map((item) => {
        return {
            code: item.code,
            label: item.label,
            length: item?.length,
            country: item.country,
            is_active: <span onClick={() => dispatch(setPutCodeCountry({id: item.id}))} style={{cursor: 'pointer', padding: '5px 20px', color: item.is_active ? '#141b33' : '#fff', background: item.is_active ? '#ffc524' : '#FF005C',  borderRadius: 20}}>{item.is_active ? 'Активен' : 'Отключен'}</span>
        }
    })

    return (
        <div style={{padding: '0 20px'}}>
            <Title 
                label="Код страны" 
                labelBtn="Добавить"
                button={() => {
                    router.history.push('/settings/code_country/create')
                }}
            />
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
                width: 'calc(100% - 40px)', 
            }}>
                <TableCasino
                    columns={columns}
                    rows={rows}
                />
            </div>
        </div>
    )
}

export default CodeCountry;